import React, { Suspense } from 'react';
import { InputBlockHome } from './inputBlockHome';
import { useScoreModel } from '../../model/context/scoreModelContext';
import { ScoreModelEditor } from './modules/scoreModelEditor/scoreModelEditor';
import { LinearProgress, Stack } from '@mui/material';

const HomePage = () => {
  const { scoreModel } = useScoreModel();
  return (
    <Stack
      direction={'row'}
      spacing={0}
      height="inherit"
      sx={{
        // Outlet occupies 70% of the page: left = 30% and middle = 40% of the full width
        '& > *:nth-of-type(1)': { flex: '0 0 calc(100% * 3 / 7)', width: 'calc(100% * 3 / 7)' },
        '& > *:nth-of-type(2)': { flex: '0 0 calc(100% * 4 / 7)', width: 'calc(100% * 4 / 7)' }
      }}>
      <Suspense fallback={<LinearProgress />}>
        <InputBlockHome scoreModel={scoreModel} />
      </Suspense>
      <ScoreModelEditor
        scoreModel={
          scoreModel ?? {
            scoreModelId: NaN,
            name: 'New Score Model',
            active: true,
            policyRules: []
          }
        }
      />
    </Stack>
  );
};

export default HomePage;
